import { Component } from '@angular/core';

@Component({
  selector: 'app-popup-top-line',
  templateUrl: './popup-top-line.component.html',
  styleUrls: ['./popup-top-line.component.scss'],
})
export class PopupTopLineComponent {}
